import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-lrc-type-value-renderer',
  templateUrl: './lrc-type-value-renderer.component.html',
  styleUrls: ['./lrc-type-value-renderer.component.scss'],
})
export class LrcTypeValueRendererComponent implements ICellRendererAngularComp {
  value: string | undefined;
  typeValue: string | undefined;
  params: HttpParams | undefined;
  data: any;

  constructor() {}

  agInit(params: ICellRendererParams): void {
    this.value = params.value;
    this.data = params.data;

    if (this.value === 'CASH_OUT') {
      this.typeValue = 'CASH OUT';
    } else if (this.value === 'PAYMENT') {
      this.typeValue = 'PAYMENT';
    } else if (this.value === 'TRANSFER') {
      this.typeValue = 'TRANSFER';
    } else if (this.value === 'CASH_IN') {
      this.typeValue = 'CASH IN';
    }

    const httpParams = (params as any)?.httpParams;
    if (httpParams) {
      this.params = httpParams;
    }
  }

  refresh(params: ICellRendererParams) {
    this.value = params.value;
    this.data = params.data;

    const httpParams = (params as any)?.httpParams;
    if (httpParams) {
      this.params = httpParams;
    }
    return true;
  }
}
